import { Component, Input } from '@angular/core';
import { TableCellComponent } from '@captiveaire/table';
import { IDeviceStatusListSummary } from '../shared/models/device-status-list-summary.interface';

@Component({
    selector: 'dl-device-status-table-cell',
    templateUrl: './device-status-table-cell.component.html'
})
export class DeviceStatusTableCellComponent extends TableCellComponent {
    public static $name: string = 'clDeviceStatusCell';

    @Input() public item: IDeviceStatusListSummary;
    @Input() public tooltipDirection: string = 'right';

}
